import { Routes } from "@angular/router";

export const FULL_ROUTES: Routes = [

    {
        path: '',
        loadChildren: () => import('../../incomeTaxDashboard/dashboard.module').then(m => m.DashboardModule)
    },
    {
        path : '',
        loadChildren: () => import('../../income-tax/income-tax.module').then(m => m.IncomeTaxModule)
    }
]
